import { render } from "./vue-ueditor-wrap.vue?vue&type=template&id=cdf51734"
import script from "./vue-ueditor-wrap.vue?vue&type=script&lang=js"
export * from "./vue-ueditor-wrap.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__